<template>
  <el-dialog title="" :visible.sync="$store.state.groupObj.groupFalg" width="90%" :append-to-body="true" :close-on-click-modal="false" center>
    <div class="tabs-container ng-scope" v-if="$store.state.groupObj.groupFalg" style="padding-bottom: 50px; margin-top: 18px">
      <div id="wrapperp">
        <ul class="nav nav-tabs">
          <li class="tabLi" v-for="(data, $index) in $store.state.groupObj.obj.langMap" :key="$index" :class="{ 'active': $index == 0 }">
            <div class="tabDiv" @click="changeTabG($index)"></div>
            <a :class="true ? 'tabG' + $index : ''" data-toggle="tab" :href="true ? '#tabG-' + $index : ''" aria-expanded="true" @click="showTabG($event, $index)">{{
              $t("message." + data.langCode)
            }}</a>
          </li>
        </ul>
      </div>
      <el-form :model="$store.state.groupObj.obj" ref="groupDetail" label-width="0px" class="demo-dynamic form-horizontal detailPage">
        <div class="tab-content">
          <div :id="'tabG-' + index" v-for="(langData, index) in $store.state.groupObj.obj.langMap" :key="index" class="tab-pane">
            <div class="form-group" v-if="$store.state.groupObj.objType == 0">
              <label class="col-sm-2 control-label">Others Title</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.sectionTitle'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.sectionTitle" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 0">
              <label class="col-sm-2 control-label">Others Content</label>
              <div class="col-sm-10">
                <div>
                  <ckeditor :editor="editor" @ready="onReady" v-model="langData.content" :config="editorConfig2"></ckeditor>
                </div>
              </div>
            </div>

            <div class="form-group" v-if="$store.state.groupObj.objType == 1">
              <label class="col-sm-2 control-label">Group title</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.title'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.title" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 14">
              <label class="col-sm-2 control-label">Contact Person</label>
              <div class="col-sm-10">
                <!-- <el-form-item 
                            :prop="'langMap.' + index + '.contactPerson'"
                            :rules="{
                              required: true, message: $t('message.required'), trigger: 'blur'
                            }"
                          >
                            <el-input v-model="langData.contactPerson" show-word-limit :maxlength="100"></el-input>
                        </el-form-item> -->
                <el-input v-model="langData.contactPerson" show-word-limit :maxlength="100"></el-input>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 14">
              <label class="col-sm-2 control-label">Phone</label>
              <div class="col-sm-10">
                <div>
                  <el-input v-model="$store.state.groupObj.obj.phoneNumber" show-word-limit :maxlength="100"></el-input>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 14">
              <label class="col-sm-2 control-label">Email</label>
              <div class="col-sm-10">
                <div>
                  <el-input v-model="$store.state.groupObj.obj.emailAddress" show-word-limit :maxlength="100"></el-input>
                </div>
              </div>
            </div>

            <div class="form-group" v-if="$store.state.groupObj.objType == 2">
              <label class="col-sm-2 control-label">Group name</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.name'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.name" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>

            <div class="form-group" v-if="$store.state.groupObj.objType == 3">
              <label class="col-sm-2 control-label">Organisation Name</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.name'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.name" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 3">
              <label class="col-sm-2 control-label">Organisation Content</label>
              <div class="col-sm-10">
                <div>
                  <ckeditor :editor="editor" @ready="onReady" v-model="langData.content" :config="editorConfig5"></ckeditor>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 3">
              <label class="col-sm-2 control-label">Organisation Image</label>
              <div class="col-sm-10">
                <div>
                  <el-input v-model="langData.image" show-word-limit :maxlength="1000"></el-input>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 3">
              <label class="col-sm-2 control-label">Alt Text</label>
              <div class="col-sm-10">
                <div>
                  <el-input v-model="langData.altText" show-word-limit :maxlength="100"></el-input>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 4">
              <label class="col-sm-2 control-label"> Visual Type </label>
              <div class="col-sm-4">
                <el-form-item
                  prop="visualType"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'change',
                  }"
                >
                  <el-select v-model="$store.state.groupObj.obj.visualType" clearable>
                    <el-option v-for="item in visualTypeObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 4 && $store.state.groupObj.obj.visualType == 'video'">
              <label class="col-sm-2 control-label">Video Url</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.image'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.image" show-word-limit :maxlength="1000"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 4 && $store.state.groupObj.obj.visualType == 'image'">
              <label class="col-sm-2 control-label">Images</label>
              <div class="col-sm-3">
                <el-form-item
                  :prop="'langMap.' + index + '.image'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'change',
                  }"
                >
                  <el-input v-model="langData.image" style="display: none" show-word-limit :maxlength="1000"></el-input>
                  <file-upload :fileUploadUrl="fileUploadUrl" :filewidth="1200" :fileheight="750" :limit="5" v-model="langData.image">
                    <template v-slot:sizeError>
                      <div style="color: red">Size error!</div>
                    </template>
                    <template v-slot:dimensionError>
                      <div style="color: red">Dimension Error!</div>
                    </template>
                    <template v-slot:sizeHint>1200 x 750, Max 5 MB.</template>
                  </file-upload>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 4 && $store.state.groupObj.obj.visualType == 'image'">
              <label class="col-sm-2 control-label">Caption</label>
              <div class="col-sm-10">
                <div>
                  <el-input v-model="langData.caption" show-word-limit :maxlength="100"></el-input>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 4 && $store.state.groupObj.obj.visualType == 'image'">
              <label class="col-sm-2 control-label">Alt Text</label>
              <div class="col-sm-10">
                <div v-if="!$store.state.groupObj.altText">
                  <el-input v-model="langData.altText" show-word-limit :maxlength="100"></el-input>
                </div>
                <el-form-item
                  v-if="$store.state.groupObj.altText"
                  :prop="'langMap.' + index + '.altText'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.altText" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 5">
              <label class="col-sm-2 control-label">Programme Name</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.programmeName'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.programmeName" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 6">
              <label class="col-sm-2 control-label">Title</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.title'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.title" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 6">
              <label class="col-sm-2 control-label"> Start Date </label>
              <div class="col-sm-4">
                <div>
                  <el-date-picker v-model="$store.state.groupObj.obj.dateJson.startDate" type="date" value-format="yyyy-MM-dd 00:00:00" placeholder="startDate"> </el-date-picker>
                </div>
              </div>
              <label class="col-sm-2 control-label"> End Date </label>
              <div class="col-sm-4">
                <div>
                  <el-date-picker v-model="$store.state.groupObj.obj.dateJson.endDate" type="date" value-format="yyyy-MM-dd 00:00:00" placeholder="endDate"> </el-date-picker>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 6">
              <label class="col-sm-2 control-label"> Start Time </label>
              <div class="col-sm-4">
                <div>
                  <el-time-picker
                    v-model="$store.state.groupObj.obj.dateJson.startTime"
                    value-format="HH:mm"
                    :picker-options="{
                      format: 'HH:mm',
                    }"
                    placeholder="startTime"
                  >
                  </el-time-picker>
                </div>
              </div>
              <label class="col-sm-2 control-label"> End Time </label>
              <div class="col-sm-4">
                <div>
                  <el-time-picker
                    v-model="$store.state.groupObj.obj.dateJson.endTime"
                    value-format="HH:mm"
                    :picker-options="{
                      format: 'HH:mm',
                    }"
                    placeholder="endTime"
                  >
                  </el-time-picker>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 6">
              <label class="col-sm-2 control-label"> Repeat </label>
              <div class="col-sm-4">
                <div>
                  <el-select v-model="$store.state.groupObj.obj.dateJson.repeat" clearable>
                    <el-option v-for="item in repeatObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 6 && $store.state.groupObj.obj.dateJson.repeat == 7">
              <label class="col-sm-2 control-label"> Frequency </label>
              <div class="col-sm-4">
                <div>
                  <el-select v-model="$store.state.groupObj.obj.dateJson.frequency" clearable>
                    <el-option v-for="item in frequencyObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 6 && $store.state.groupObj.obj.dateJson.frequency == 1">
              <label class="col-sm-2 control-label"> Day </label>
              <div class="col-sm-4">
                <div>
                  <el-input type="number" min="1" max="99" v-model="$store.state.groupObj.obj.dateJson.day" show-word-limit></el-input>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 6 && $store.state.groupObj.obj.dateJson.frequency == 2">
              <label class="col-sm-2 control-label"> Week </label>
              <div class="col-sm-4">
                <div>
                  <el-select v-model="$store.state.groupObj.obj.dateJson.week" multiple filterable clearable>
                    <el-option v-for="item in weekObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 6 && $store.state.groupObj.obj.dateJson.frequency == 3">
              <label class="col-sm-2 control-label"> Month </label>
              <div class="col-sm-4">
                <div>
                  <el-select v-model="$store.state.groupObj.obj.dateJson.month" multiple filterable clearable>
                    <el-option v-for="item in monthObj" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 6 && $store.state.groupObj.obj.dateJson.frequency == 4">
              <label class="col-sm-2 control-label"> Year </label>
              <div class="col-sm-4">
                <div>
                  <el-select v-model="$store.state.groupObj.obj.dateJson.year" multiple filterable clearable>
                    <el-option v-for="item in yearObj" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 7">
              <label class="col-sm-2 control-label">Name</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.name'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.name" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 8">
              <label class="col-sm-2 control-label">Title</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.title'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.title" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 8">
              <label class="col-sm-2 control-label">Sub Title</label>
              <div class="col-sm-10">
                <div>
                  <el-input v-model="langData.subTitle" show-word-limit :maxlength="100"></el-input>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 8">
              <label class="col-sm-2 control-label">Image</label>
              <div class="col-sm-10">
                <div>
                  <el-input v-model="langData.image" show-word-limit :maxlength="1000"></el-input>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 8">
              <label class="col-sm-2 control-label">Alt Text</label>
              <div class="col-sm-10">
                <div>
                  <el-input v-model="langData.altText" show-word-limit :maxlength="100"></el-input>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 8">
              <label class="col-sm-2 control-label">Content</label>
              <div class="col-sm-10">
                <div>
                  <ckeditor :editor="editor" @ready="onReady" v-model="langData.content" :config="editorConfig1"></ckeditor>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 9">
              <label class="col-sm-2 control-label">Name</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.name'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.name" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 10">
              <label class="col-sm-2 control-label">Name</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.name'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.name" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 10">
              <label class="col-sm-2 control-label">Image</label>
              <div class="col-sm-10">
                <div>
                  <el-input v-model="langData.image" show-word-limit :maxlength="1000"></el-input>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 10">
              <label class="col-sm-2 control-label">Alt Text</label>
              <div class="col-sm-10">
                <div>
                  <el-input v-model="langData.altText" show-word-limit :maxlength="100"></el-input>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 10">
              <label class="col-sm-2 control-label">Introduction</label>
              <div class="col-sm-10">
                <div>
                  <ckeditor :editor="editor" @ready="onReady" v-model="langData.introduction" :config="editorConfig3"></ckeditor>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 11 || $store.state.groupObj.objType == 15">
              <label class="col-sm-2 control-label">Title</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.title'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.title" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 12">
              <label class="col-sm-2 control-label">Name</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.name'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.name" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 12">
              <label class="col-sm-2 control-label">Image</label>
              <div class="col-sm-10">
                <div>
                  <el-input v-model="langData.image" show-word-limit :maxlength="1000"></el-input>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 12">
              <label class="col-sm-2 control-label">Alt Text</label>
              <div class="col-sm-10">
                <div>
                  <el-input v-model="langData.altText" show-word-limit :maxlength="100"></el-input>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 12">
              <label class="col-sm-2 control-label">Introduction</label>
              <div class="col-sm-10">
                <div>
                  <el-input type="textarea" :rows="2" v-model="langData.introduction"></el-input>
                </div>
              </div>
            </div>

            <div class="form-group" v-if="$store.state.groupObj.objType == 13">
              <label class="col-sm-2 control-label"> Talks / Forums </label>
              <div class="col-sm-4">
                <el-form-item
                  prop="type"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'change',
                  }"
                >
                  <el-select v-model="$store.state.groupObj.obj.type" clearable>
                    <el-option v-for="item in typeObj" :key="item.label" :label="item.label" :value="item.label"> </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 13">
              <label class="col-sm-2 control-label">Talks / Forums Name</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.name'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.name" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 13">
              <label class="col-sm-2 control-label"> Venue </label>
              <div class="col-sm-4">
                <el-form-item
                  prop="venue"
                  :rules="{
                    required: false,
                    message: $t('message.required'),
                    trigger: 'change',
                  }"
                >
                  <el-select v-model="$store.state.groupObj.obj.venue" clearable v-bind:placeholder="$t('message.PleaseSelect')">
                    <el-option v-for="item in venueObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 13">
              <label class="col-sm-2 control-label"> Date </label>
              <div class="col-sm-4">
                <el-form-item
                  prop="eventDate"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'change',
                  }"
                >
                  <el-date-picker v-model="$store.state.groupObj.obj.eventDate" type="date" value-format="yyyy-MM-dd 00:00:00" placeholder="eventDate"> </el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 13">
              <label class="col-sm-2 control-label"> Start Time </label>
              <div class="col-sm-4">
                <div>
                  <el-time-picker
                    v-model="$store.state.groupObj.obj.startTime"
                    value-format="HH:mm"
                    :picker-options="{
                      format: 'HH:mm',
                    }"
                    placeholder="startTime"
                  >
                  </el-time-picker>
                </div>
              </div>
              <label class="col-sm-2 control-label"> End Time </label>
              <div class="col-sm-4">
                <div>
                  <el-time-picker
                    v-model="$store.state.groupObj.obj.endTime"
                    value-format="HH:mm"
                    :picker-options="{
                      format: 'HH:mm',
                    }"
                    placeholder="endTime"
                  >
                  </el-time-picker>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 13">
              <label class="col-sm-2 control-label">Speaker / Guest</label>
              <div class="col-sm-10">
                <div>
                  <el-input v-model="langData.speaker" show-word-limit :maxlength="100"></el-input>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 17">
              <label class="col-sm-2 control-label">Title</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.title'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.title" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 17">
              <label class="col-sm-2 control-label"> Event Types </label>
              <div class="col-sm-4">
                <el-form-item
                  prop="eventTypes"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'change',
                  }"
                >
                  <el-select v-model="$store.state.groupObj.obj.eventTypes" clearable>
                    <el-option v-for="item in eventTypeObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 17">
              <label class="col-sm-2 control-label"> Venue </label>
              <div class="col-sm-4">
                <el-form-item
                  prop="venue"
                  :rules="{
                    required: false,
                    message: $t('message.required'),
                    trigger: 'change',
                  }"
                >
                  <el-select v-model="$store.state.groupObj.obj.venue" clearable v-bind:placeholder="$t('message.PleaseSelect')">
                    <el-option v-for="item in venueObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 17">
              <label class="col-sm-2 control-label"> Start Time </label>
              <div class="col-sm-4">
                <div>
                  <el-time-picker
                    v-model="$store.state.groupObj.obj.startTime"
                    value-format="HH:mm"
                    :picker-options="{
                      format: 'HH:mm',
                    }"
                    placeholder="startTime"
                  >
                  </el-time-picker>
                </div>
              </div>
              <label class="col-sm-2 control-label"> End Time </label>
              <div class="col-sm-4">
                <div>
                  <el-time-picker
                    v-model="$store.state.groupObj.obj.endTime"
                    value-format="HH:mm"
                    :picker-options="{
                      format: 'HH:mm',
                    }"
                    placeholder="endTime"
                  >
                  </el-time-picker>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 19">
              <label class="col-sm-2 control-label">Show Title</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.showTitle'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.showTitle" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 19">
              <label class="col-sm-2 control-label">Images</label>
              <div class="col-sm-3">
                <el-form-item
                  :prop="'langMap.' + index + '.image'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'change',
                  }"
                >
                  <el-input v-model="langData.image" style="display: none" show-word-limit :maxlength="1000"></el-input>
                  <file-upload :fileUploadUrl="fileUploadUrl" :filewidth="1200" :fileheight="750" :limit="5" v-model="langData.image">
                    <template v-slot:sizeError>
                      <div style="color: red">Size error!</div>
                    </template>
                    <template v-slot:dimensionError>
                      <div style="color: red">Dimension Error!</div>
                    </template>
                    <template v-slot:sizeHint>1200 x 750, Max 5 MB.</template>
                  </file-upload>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 19">
              <label class="col-sm-2 control-label">Caption</label>
              <div class="col-sm-10">
                <div>
                  <el-input v-model="langData.caption" show-word-limit :maxlength="100"></el-input>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 19">
              <label class="col-sm-2 control-label">Alt Text</label>
              <div class="col-sm-10">
                <div>
                  <el-input v-model="langData.altText" show-word-limit :maxlength="100"></el-input>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 19">
              <label class="col-sm-2 control-label"> Start Date </label>
              <div class="col-sm-4">
                <div>
                  <el-date-picker v-model="$store.state.groupObj.obj.date" type="date" value-format="yyyy-MM-dd 00:00:00" placeholder="date"> </el-date-picker>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 19">
              <label class="col-sm-2 control-label"> Start Time </label>
              <div class="col-sm-4">
                <div>
                  <el-time-picker
                    v-model="$store.state.groupObj.obj.startTime"
                    value-format="HH:mm"
                    :picker-options="{
                      format: 'HH:mm',
                    }"
                    placeholder="startTime"
                  >
                  </el-time-picker>
                </div>
              </div>
              <label class="col-sm-2 control-label"> End Time </label>
              <div class="col-sm-4">
                <div>
                  <el-time-picker
                    v-model="$store.state.groupObj.obj.endTime"
                    value-format="HH:mm"
                    :picker-options="{
                      format: 'HH:mm',
                    }"
                    placeholder="endTime"
                  >
                  </el-time-picker>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 88">
              <label class="col-sm-2 control-label"> Status </label>
              <div class="col-sm-10">
                <el-select v-model="$store.state.groupObj.obj.status" clearable>
                  <el-option v-for="item in ticketStatusObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 88" style="padding-left: 30px">Choose either the Platform Logo or the Platform Language/Type</div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 88">
              <label class="col-sm-2 control-label"> Platform Logo </label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.logo'"
                  :rules="{
                    required: !langData.logo && !langData.platformName ? true : false,
                    message: 'Choose either the Platform Logo or the Platform Language/Type',
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.logo" style="display: none" show-word-limit></el-input>
                  <file-upload :fileUploadUrl="fileUploadUrl" :limit="5" :showDelete="true" v-model="langData.logo" :callback="diplaylogo">
                    <template v-slot:sizeError>
                      <div style="color: red">Size error!</div>
                    </template>
                    <template v-slot:dimensionError>
                      <div style="color: red">Dimension Error!</div>
                    </template>
                    <template v-slot:sizeHint>
                      <div style="font-size: 12px">(Suggested Size: 1000 X 1000; ratio 1:1)</div>
                      <div>Max 5 MB.</div>
                    </template>
                  </file-upload>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 88">
              <label class="col-sm-2 control-label"> Platform Language/Type </label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.platformName'"
                  :rules="{
                    required: !langData.logo && !langData.platformName ? true : false,
                    message: 'Choose either the Platform Logo or the Platform Language/Type',
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.platformName" @change="displayOtherLanguage('platformName', index)" show-word-limit :maxlength="langData.langCode == 'en_US' ? 10 : 4"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 88">
              <label class="col-sm-2 control-label">Platform Title </label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.desciption'"
                  :rules="{
                    required: checkRequired('desciption'),
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.desciption" @change="displayOtherLanguage('desciption', index)" show-word-limit :maxlength="langData.langCode == 'en_US' ? 45 : 28"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 88">
              <label class="col-sm-2 control-label">Platform notice (optional) </label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.platformNotice'"
                  :rules="{
                    required: checkRequired('platformNotice'),
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.platformNotice" @change="displayOtherLanguage('platformNotice', index)" show-word-limit :maxlength="langData.langCode == 'en_US' ? 110 : 50"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 88">
              <label class="col-sm-2 control-label"> Type</label>
              <div class="col-sm-10">
                <el-select v-model="langData.linkType" @change="changelinkType(langData.linkType)" clearable>
                  <el-option :key="1" label="External link" :value="1"> </el-option>
                  <el-option :key="2" label="RSVP ID" :value="2"> </el-option>
                </el-select>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 88">
              <label v-if="langData.linkType == 1" class="col-sm-2 control-label"> External link </label>
              <label v-if="langData.linkType == 2" class="col-sm-2 control-label"> RSVP ID</label>
              <div class="col-sm-10" v-if="langData.linkType">
                <el-form-item
                  :prop="'langMap.' + index + '.externalLink'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.externalLink" @change="displayOtherLanguage('externalLink', index)" show-word-limit :maxlength="500"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 90">
              <label class="col-sm-2 control-label">Privilege title </label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.privilegeTitle'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.privilegeTitle" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 90">
              <label class="col-sm-2 control-label"> Privilege detail</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.privilegeDetial'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input type="textarea" v-model="langData.privilegeDetial" show-word-limit :maxlength="1000"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 90">
              <label class="col-sm-2 control-label"> Icon Type </label>
              <div class="col-sm-4">
                <el-select v-model="$store.state.groupObj.obj.iconType" clearable>
                  <el-option v-for="item in privilegeDetialTypeObj" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 91">
              <label class="col-sm-2 control-label">Question title </label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.questionTitle'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.questionTitle" show-word-limit :maxlength="200"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 91">
              <label class="col-sm-2 control-label"> Answer</label>
              <div class="col-sm-10">
                <el-form-item
                  :prop="'langMap.' + index + '.answer'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input type="textarea" v-model="langData.answer" show-word-limit :maxlength="1000"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 92">
              <label class="col-sm-2 control-label">Member Tier </label>
              <div class="col-sm-9">
                <el-form-item
                  :prop="'langMap.' + index + '.memberTier'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.memberTier" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 92">
              <label class="col-sm-2 control-label">Description (Annual/ Quarter/ Monthly) </label>
              <div class="col-sm-9">
                <el-form-item
                  :prop="'langMap.' + index + '.description'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.description" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 92">
              <label class="col-sm-2 control-label">Price </label>
              <div class="col-sm-9">
                <el-form-item
                  :prop="'langMap.' + index + '.price'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.price" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 92">
              <label class="col-sm-2 control-label">Remarks </label>
              <div class="col-sm-9">
                <el-form-item
                  :prop="'langMap.' + index + '.remarks'"
                  :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.remarks" show-word-limit :maxlength="100"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.groupObj.objType == 92">
              <label class="col-sm-2 control-label">External link </label>
              <div class="col-sm-9">
                <el-form-item
                  :prop="'langMap.' + index + '.priceUrl'"
                  :rules="{
                    required: false,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }"
                >
                  <el-input v-model="langData.priceUrl"></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="form-group" v-if="$store.state.groupObj.objType == 16">
            <label class="col-sm-2 control-label"> Date </label>
            <div class="col-sm-4">
              <div>
                <el-date-picker v-model="$store.state.groupObj.obj.scheduleDate" type="date" value-format="yyyy-MM-dd 00:00:00" placeholder="scheduleDate"> </el-date-picker>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$store.state.groupObj.groupFalg = false">Cancel</el-button>
      <el-button type="primary" @click="checkEvent()">Confirm</el-button>
    </span>
  </el-dialog>
</template>
<script>
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import ClassicEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import fileupload from "./fileupload";
const upload = require("../../upload");
import config from "../../config";
export default {
  name: "groupDlgController",
  mixins: [config.globalMixin],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: ["bold", "italic", "underline", "Link", "bulletedList", "numberedList"],
      },
      editorConfig1: {
        toolbar: ["bold", "italic", "underline", "bulletedList", "numberedList"],
      },
      editorConfig2: {
        toolbar: ["bold", "italic", "underline", "Link", "bulletedList", "numberedList", "imageUpload"],
        extraPlugins: [upload.MyCustomUploadAdapterPlugin],
      },
      editorConfig3: {
        toolbar: ["bold", "italic", "underline"],
      },
      editorConfig4: {
        toolbar: ["bold", "italic", "underline", "bulletedList", "numberedList", "imageUpload"],
        extraPlugins: [upload.MyCustomUploadAdapterPlugin],
      },
      editorConfig5: {
        toolbar: ["bold", "italic", "underline", "Link"],
      },
      venueObj: [],
      venueList: [],
      frequencyObj: [],
      weekObj: [],
      monthObj: [],
      yearObj: [],
      ticketStatusObj: [],
      privilegeDetialTypeObj: ["calendar", "camera", "dinning", "exclusive information", "exhibition", "general admission", "gift", "lounge", "member activities", "private viewing", "shop", "video"],
    };
  },
  components: {
    ClassicEditor,
    "file-upload": fileupload,
  },
  methods: {
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },
    cancel: function () {
      this.$store.commit("setgroup", { string: "", boolean: false });
    },
    changeTabG: function (id) {
      $(".tabG" + id)
        .parent()
        .find("a")
        .click();
    },
    showTabG: function ($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          // $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          // $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
    checkEvent: function () {
      this.$refs["groupDetail"].validate(valid => {
        if (this.$store.state.groupObj.objType == 14) {
          if (
            (this.$store.state.groupObj.obj.langMap[0].contactPerson && this.$store.state.groupObj.obj.langMap[1].contactPerson && this.$store.state.groupObj.obj.langMap[2].contactPerson) ||
            this.$store.state.groupObj.obj.phoneNumber ||
            this.$store.state.groupObj.obj.emailAddress
          ) {
            valid = true;
          } else {
            valid = false;
          }
        }
        if (valid) {
          this.addEvent();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    addEvent: function () {
      this.$store.state.groupObj.groupFalg = false;
      this.$store.state.groupObj.callback();
    },
    async venueListEvent() {
      let objdata = this.getAuthObj();
      objdata.sortField = "id";
      objdata.sortType = "ASC";
      objdata.startRow = 0;
      objdata.maxRows = 1000000;
      objdata.status = 1;
      objdata.apiUrl = "/getVenueList";
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      this.venueList = data.data.resultList;
      this.venueObj = [];
      for (var i = 0; i < this.venueList.length; i++) {
        this.venueObj.push({
          value: this.venueList[i].id,
          label: this.getObject(this.venueList[i].langMap, this.langKey[0]).content,
        });
      }
    },
    changelinkType(linkType) {
      this.$store.state.groupObj.obj.langMap.forEach(item => {
        item.linkType = linkType;
        item.externalLink = "";
      });
    },
    displayOtherLanguage(field, index) {
      //   let langMap = this.$store.state.groupObj.obj.langMap;
      //   let value = langMap[index][field];
      //   langMap.forEach(item => {
      //     if (!item[field]) {
      //       item[field] = value;
      //     }
      //   });
    },
    diplaylogo(result, item) {
      //   this.$store.state.groupObj.obj.langMap.forEach(item => {
      //     if (!item.logo) {
      //       item.logo = result.fullName;
      //     }
      //   });
    },
    checkRequired(field) {
      let langMap = this.$store.state.groupObj.obj.langMap;
      let required = false;
      langMap.forEach(item => {
        if (item[field]) {
          required = true;
        }
      });
      return required;
    },
  },
  computed: {
    _obj() {
      return this.$store.state.groupObj.groupFalg;
    },
  },
  watch: {
    _obj: function () {
      if (this.$store.state.groupObj.groupFalg) {
        this.venueListEvent();
      }
      setTimeout(function () {
        $(".tabG" + 1)
          .parent()
          .find("a")
          .click();

        $(".tabG" + 0)
          .parent()
          .find("a")
          .click();
      });
    },
  },
  mounted() {
    this.eventTypeObj = [
      {
        value: "1",
        label: "Performing Arts",
      },
      {
        value: "2",
        label: "Exhibitions",
      },
      {
        value: "3",
        label: "Talks / Forums",
      },
      {
        value: "4",
        label: "Guided Tour",
      },
      {
        value: "5",
        label: "Workshops",
      },
      {
        value: "6",
        label: "Screening",
      },
      {
        value: "7",
        label: "Festival",
      },
      {
        value: "8",
        label: "Other",
      },
    ];

    this.ticketStatusObj = [
      {
        value: true,
        label: "Active",
      },
      {
        value: false,
        label: "Inactive",
      },
    ];
    this.repeatObj = [
      {
        value: "1",
        label: "Never",
      },
      {
        value: "2",
        label: "Every Day",
      },
      {
        value: "3",
        label: "Every Week",
      },
      {
        value: "4",
        label: "Every 2 Weeks",
      },
      {
        value: "5",
        label: "Every Month",
      },
      {
        value: "6",
        label: "Every Year",
      },
      {
        value: "7",
        label: "Custom",
      },
    ];
    this.typeObj = [
      {
        label: "Talk",
      },
      {
        label: "Forum",
      },
    ];
    this.visualTypeObj = [
      {
        value: "video",
        label: "video",
      },
      {
        value: "image",
        label: "image",
      },
    ];
    this.frequencyObj = [
      {
        value: "1",
        label: "Day",
      },
      {
        value: "2",
        label: "Week",
      },
      {
        value: "3",
        label: "Month",
      },
      {
        value: "4",
        label: "Year",
      },
    ];
    this.weekObj = [
      {
        value: "1",
        label: "Monday",
      },
      {
        value: "2",
        label: "Tuesday",
      },
      {
        value: "3",
        label: "Wednesday",
      },
      {
        value: "4",
        label: "Thursday",
      },
      {
        value: "5",
        label: "Friday",
      },
      {
        value: "6",
        label: "Saturday",
      },
      {
        value: "7",
        label: "Sunday",
      },
    ];
    this.monthObj = [
      {
        value: "1",
      },
      {
        value: "2",
      },
      {
        value: "3",
      },
      {
        value: "4",
      },
      {
        value: "5",
      },
      {
        value: "6",
      },
      {
        value: "7",
      },
      {
        value: "8",
      },
      {
        value: "9",
      },
      {
        value: "10",
      },
      {
        value: "11",
      },
      {
        value: "12",
      },
      {
        value: "13",
      },
      {
        value: "14",
      },
      {
        value: "15",
      },
      {
        value: "16",
      },
      {
        value: "17",
      },
      {
        value: "18",
      },
      {
        value: "19",
      },
      {
        value: "20",
      },
      {
        value: "21",
      },
      {
        value: "22",
      },
      {
        value: "23",
      },
      {
        value: "24",
      },
      {
        value: "25",
      },
      {
        value: "26",
      },
      {
        value: "27",
      },
      {
        value: "28",
      },
      {
        value: "29",
      },
      {
        value: "30",
      },
      {
        value: "31",
      },
    ];
    this.yearObj = [
      {
        value: "1",
      },
      {
        value: "2",
      },
      {
        value: "3",
      },
      {
        value: "4",
      },
      {
        value: "5",
      },
      {
        value: "6",
      },
      {
        value: "7",
      },
      {
        value: "8",
      },
      {
        value: "9",
      },
      {
        value: "10",
      },
      {
        value: "11",
      },
      {
        value: "12",
      },
    ];
  },
};
</script>
